import InventoryTerms from './inventory/InventoryTerms';
import React from 'react';
import { X, Plus, Minus, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { ScrollArea } from './ui/scroll-area';

const CartSidebar = () => {
  const navigate = useNavigate();
  const {
    cart,
    isCartOpen,
    setIsCartOpen,
    removeFromCart,
    updateQuantity,
    getCartTotal, checkingCart, cartError, validateCart, hasUnavailable
  } = useCart();

  const handleCheckout = async () => {
    if (!(await validateCart())) return;
    setIsCartOpen(false);
    navigate('/checkout');
  };

  return (
    <Sheet open={isCartOpen} onOpenChange={setIsCartOpen}>
      <SheetContent className="w-full sm:max-w-lg flex flex-col p-0 dark:bg-[#1E1E1E] dark:border-brand-border">
        <SheetHeader className="p-6 border-b dark:border-brand-border">
          <SheetTitle className="text-lg font-medium dark:text-brand-text">Корзина</SheetTitle>
        </SheetHeader>

        {cart.length === 0 ? (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-brand-text dark:text-brand-text">Корзина пуста</p>
          </div>
        ) : (
          <>
            <ScrollArea className="flex-1 p-6">
              <div className="space-y-4">
                {cart.map((item) => (
                  <div
                    key={`${item.id}-${item.size}`}
                    className="flex gap-4 p-4 bg-brand-surface dark:bg-brand-surface rounded-lg"
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-20 h-24 object-cover rounded"
                    />
                    <div className="flex-1 min-w-0">
                      <h4 className="font-medium text-sm truncate dark:text-brand-text">{item.name}</h4>
                      <p className="text-xs text-brand-text dark:text-brand-text mt-1">
                        арт: {item.article} | Размер: {item.size}
                      </p>
                      {item.unavailable && <p className="text-red-300 text-xs mt-2" role="status">{item.unavailable}</p>}
                      <div className="flex flex-wrap gap-3 items-center justify-between mt-3">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => updateQuantity(item.id, item.size, item.quantity - 1)}
                            className="w-7 h-7 flex items-center justify-center border dark:border-brand-border rounded hover:bg-brand-surface dark:hover:bg-brand-surface transition-colors dark:text-brand-text"
                          >
                            <Minus className="w-3 h-3" />
                          </button>
                          <span className="w-8 text-center text-sm dark:text-brand-text">{item.quantity}</span>
                          <button
                            disabled={!!item.unavailable || item.quantity >= 99}
                            onClick={() => updateQuantity(item.id, item.size, item.quantity + 1)}
                            className="w-7 h-7 flex items-center justify-center border dark:border-brand-border rounded hover:bg-brand-surface dark:hover:bg-brand-surface transition-colors dark:text-brand-text"
                          >
                            <Plus className="w-3 h-3" />
                          </button>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className="font-semibold text-sm whitespace-nowrap dark:text-brand-text">
                            {(item.price * item.quantity).toLocaleString('ru-RU')} ₽
                          </span>
                          <button
                            onClick={() => removeFromCart(item.id, item.size)}
                            className="text-brand-text hover:text-brand-text transition-colors"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-6 pb-4"><InventoryTerms items={cart}/></div>
            </ScrollArea>

            <div className="border-t dark:border-brand-border p-6 space-y-4">
              {cartError && <div role="status" className="text-sm">{cartError} <button className="underline" disabled={checkingCart} onClick={validateCart}>Проверить снова</button></div>}
              <div className="flex justify-between items-center">
                <span className="text-brand-text dark:text-brand-text">Итого:</span>
                <span className="text-xl font-semibold dark:text-brand-text">
                  {getCartTotal().toLocaleString('ru-RU')} ₽
                </span>
              </div>
              <Button
                disabled={checkingCart || hasUnavailable}
                onClick={handleCheckout}
                className="w-full h-12 bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text hover:bg-brand-surface dark:hover:bg-brand-surface text-base font-medium"
              >
                {checkingCart ? 'Проверяем товары…' : 'Оформить заказ'}
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartSidebar;
